<template>
  <div class="content flex-box">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-hotel-room"
      entity-name="房型"
      add-btn="添加房型"
      hide-show-detail
      :hide-action="!editable"
      :modal-width="480"
      :before-update="beforeUpdate"
      :modal-form="modalForm"
      :query="query"
      :action="action"
      :columns="columns"
      :rules="rules">
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.keyword" placeholder="输入房型查询"></a-input>
        </a-form-model-item>
        <a-form-model-item label="">
          <a-select
            placeholder="选择酒店筛选"
            @change="updateList"
            :options="hotelList"
            v-model="form.hotel_id"
            style="width: 180px">
          </a-select>
        </a-form-model-item>
      </template>
      <template v-slot:edit="{form}">
        <a-form-model-item label="酒店" prop="hotel">
          <select-entity
            v-model="form.hotel"
            btn-text="选择酒店"
            url="/activity/activity-hotel"
            :query="`&filter[activity_id]=${activity.id}`"
            :columns="hotelColumns">
          </select-entity>
        </a-form-model-item>
        <a-form-model-item label="房型" prop="type">
          <a-input v-model="form.type" placeholder="请输入房型"></a-input>
        </a-form-model-item>
        <a-form-model-item label="房间数量" prop="count">
          <a-input-number :min="1" v-model="form.count" placeholder="请输入房间数量" style="width: 100%;"></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="可入住人数" prop="count">
          <a-input-number :min="1" v-model="form.need_num" placeholder="请输入每个房间可入住人数" style="width: 100%;"></a-input-number>
        </a-form-model-item>
<!--        <a-form-model-item label="房间号">-->
<!--          <tag-list v-model="form.num" :limit="-1" :length="-1" title="添加"></tag-list>-->
<!--        </a-form-model-item>-->
      </template>
    </data-list>
  </div>
</template>

<script>
    import mixins from "../mixins";

    export default {
        name: "ActivityHotelRoom",
        data() {
            return {
                columns: [
                    {title: '酒店名称', dataIndex: 'hotel_name', customRender: (text, record) => record.hotel ? record.hotel.name: '--'},
                    {title: '酒店地址', dataIndex: 'hotel_address', customRender: (text, record) => record.hotel ? record.hotel.location: '--'},
                    {title: '房间数量', dataIndex: 'count'},
                    {title: '可入住人数', dataIndex: 'need_num'},
                    // {title: '房间号', dataIndex: 'num'},
                ],
                rules: {
                    hotel: [{ required: true, message: '请选择酒店', trigger: 'change' }],
                    type: [{ required: true, message: '请输入房型', trigger: 'blur' }],
                    count: [{ required: true, message: '请输入房间数量', trigger: 'change' }],
                },
                hotelList: [{key: 0, title: '所有酒店'}],
                hotelColumns: [
                    {title: '酒店名称', dataIndex: 'name'},
                    {title: '酒店地址', dataIndex: 'location'},
                ],
                visible: false,
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                moduleKey: 'stay-hotel',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '&expand=hotel';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        watch: {
            activity() {
                this.getHotelList();
            }
        },
        created() {
            this.getHotelList();
        },
        methods: {
            getHotelList() {
                const activity = this.activity;
                if(activity) {
                    const url = `/activity/activity-hotel?pageSize=1000&filter[activity_id]=${activity.id}`;
                    this.$axios(url).then(res => {
                        const list = res.data.map(item => new Object({key: item.id, title: item.name}));
                        this.hotelList.push(...list);
                    })
                }
            },
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                }
                form.hotel_id = form.hotel.id;
                fn();
            },
            updateList() {
                this.$refs.dataList.getList();
            },
        }
    }
</script>

<style scoped lang="less">
</style>
